import { render, staticRenderFns } from "./GoxipCircleRewardList.vue?vue&type=template&id=c3bed224&scoped=true&"
import script from "./GoxipCircleRewardList.vue?vue&type=script&lang=js&"
export * from "./GoxipCircleRewardList.vue?vue&type=script&lang=js&"
import style0 from "./GoxipCircleRewardList.vue?vue&type=style&index=0&id=c3bed224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bed224",
  null
  
)

export default component.exports